/**
 * Canonical guardrail factor labels and sub-check row labels.
 * Used by GuardrailsTag and test utilities.
 */

export const FACTOR_LABELS: Record<string, string> = {
  owners: 'Ownership',
  documentation: 'Documentation',
  mandatoryFacet: 'Mandatory Facets',
  validation: 'Validation',
};

export const SUBCHECK_LABELS = {
  engineeringOwner: 'Engineering Owner',
  productOwner: 'Product Owner',
  documentationLink: 'Documentation Link',
  mandatoryFacets: 'Mandatory Facets',
  validation: 'Validation',
  enabledValidation: 'Enabled validation',
} as const;
